module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG1001-ac0a39178657a64736c606057b21f111.png";